export default () => ({
  collection: [],
  groupConfig: {},
  errors: [],
  hasErrors: false,
  isLoading: false,
})